import { IPagination, IPaginationDTO } from '@/models/pagination.model';

export enum ProductsEndpoints {
  PRODUCTS_IMPORT = '/products/import',
  PRODUCTS_IMPORT_TEMPLATE = '/products/import/template',
  STOCKS_IMPORT = 'products/import/stocks',
  STOCKS_IMPORT_TEMPLATE = 'products/import/stocks/template',
}

export enum ImportType {
  STOCK = 'stock',
  PRODUCT = 'product',
  FILTER_VALUE = 'filter_value',
}

export enum ImportStatusEnum {
  PROCESSING = 'Processing',
  FINISHED = 'Finished',
  FAILED = 'Failed',
}

export interface IImportModel {
  created_at: string;
  filterable: boolean;
  id: string;
  is_active: boolean;
  max: string;
  min: string;
  position: number;
  required: boolean;
  slug: string;
  title: string;
}

export interface IProductsImportItem {
  id: string;
  partner: string;
  author: string;
  type: ImportType;
  status: ImportStatusEnum;
  progress_count: number;
  total_count: number;
  error_count: number;
  errors_url: string | null;
  created_at: string;
  filter_name?: string;
  filter_id?: string;
  import_model?: IImportModel;
}

export interface IStocksImportItem {
  id: string;
  partner: string;
  author: string;
  type: ImportType;
  status: ImportStatusEnum;
  progress_count: number;
  total_count: number;
  error_count: number;
  errors_url: string | null;
  created_at: string;
}

// ----------------- DTOs ----------------

export interface IImportProductsDTO {
  partner_id: string;
  category_id: string;
  with_photos?: string;
  file?: File;
}

export interface IGetImportsListDTO extends Partial<IPaginationDTO> {
  partner_id?: string;
  active?: '0' | '1';
  limit?: number;
}

export interface IProductsImportTemplateDTO {
  category_id?: string;
  partner_id?: string;
  filled?: string;
}

export interface IImportStocksDTO {
  category_id: string;
  partner_id: string;
  file?: File;
}

export interface IStocksImportTemplateDTO {
  category_id?: string;
  partner_id?: string;
  filled?: string;
}

export enum ExportEndpoints {
  EXPORT_STATUS = '/export',
}

export enum ExportStatusEnum {
  PROCESSING = 'Processing',
  FINISHED = 'Finished',
  FAILED = 'Failed',
}

export interface IExportJob {
  id: string;
  type: string;
  region: string | null;
  status: ExportStatusEnum;
  result_file: string | null;
  total_count: number;
  progress_count: number;
  error_count: number;
  errors_file: string | null;
  error_message: string | null;
  created_at: string;
  updated_at: string;
}

export interface ITemplateExportProgress {
  progress: number;
  total: number;
}

// ------------ Responses --------------

export interface IProductsImportTemplateResponse {
  data: { url: string };
}

export interface IImportsListResponse {
  data: IProductsImportItem[];
  meta: IPagination;
}

export interface IStocksImportTemplateResponse {
  data: IExportJob;
}

export interface IExportStatusResponse {
  data: IExportJob;
}

export interface IStocksImportsListResponse {
  data: IStocksImportItem[];
  meta: IPagination;
}
